export enum FrequencyOfCommunication {    
    EveryDay = 1,
    SeveralTimesPerWeek = 2,
    SeveralTimesPerMonth = 3,
    OnceAMonth = 4,
    LessThanOnceAMonth = 5
}